export default "__VITE_ASSET__DBjoulre__"